import { SimpleForm } from 'react-admin';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';
import { RequestOneOffCheckProps } from './types';

const RequestOneOffCheck = ({ checks, onClose, record, worker, ...props }: RequestOneOffCheckProps) => {
  return (
    <CreateStyled title="Add Custom Check" {...props}>
      <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
        <FormContent checks={checks} onClose={onClose} record={record} worker={worker} />
      </SimpleForm>
    </CreateStyled>
  );
};

export default RequestOneOffCheck;
